import AppCustomApi from '@apis/custom/AppCustomApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const appCustomQueries = createQueryKeys('appCustom', {
    detail: () => ({
        queryKey: ['detail'],
        queryFn: () => AppCustomApi.getAppCustom(),
    }),
});

export default appCustomQueries;
